import { axiosV1 } from 'interceptors/axios';
import actionTypes from 'redux/actions/actionTypes';
import { decryptResponse } from 'utils/token';
import { dispatchError } from 'utils/dispatchError';

export const getSocietyEmployeesPlans = (societyId) => async (dispatch) => {
  try {
    const query = societyId ? { params: { societyId } } : { params: {} };

    const { data } = await axiosV1.get(`/employeesPlans`, query);

    const decodedData = await decryptResponse(data);

    dispatch({
      type: actionTypes.GET_EMPLOYEES_PLANS,
      data: decodedData,
    });
  } catch (error) {
    return dispatchError(error, dispatch);
  }
};

export const updateEmployeesPlan =
  (employeesPlanId, updateEmployeesPlanData) => async (dispatch) => {
    const body = {
      _id: employeesPlanId,
      ...updateEmployeesPlanData,
    };

    try {
      const { data } = await axiosV1.put(`/employeesPlans`, body);

      const decodedData = await decryptResponse(data);

      dispatch({
        type: actionTypes.UPDATE_EMPLOYEES_PLAN,
        employeesPlan: decodedData,
      });
    } catch (error) {
      return dispatchError(error, dispatch);
    }
  };
